export default __webpack_public_path__ + "static/media/Long_Yellow.f23602c0.png";